import { Directive, Input, OnInit, Renderer2, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IdentityStore } from '../identity-store';
import { switchMap, filter, map, tap, distinctUntilChanged } from 'rxjs/operators';
import { identityConstants } from '../identity-constants';

@Directive({
  selector: '[mmAuthorize]'
})
export class AuthorizeDirective implements OnInit {

  authorize$ = new BehaviorSubject<string>(undefined);
  constructor(private store: IdentityStore, private render2: Renderer2, private elementRef: ElementRef) {

  }

  ngOnInit(): void {
    this.store.permissionsSubject.pipe(
      switchMap(permissions => this.authorize$.pipe(
        filter(authorize => authorize != undefined),
        map(authorize => {
          return {
            authorize, permissions
          }
        }))
      ),
      map(obj => {
        return obj.permissions.findIndex(p => p.toLowerCase().startsWith(obj.authorize)) >= 0;
      }),
      distinctUntilChanged(),
      tap(hasPermission => {
        if (hasPermission) {
          this.render2.removeClass(this.elementRef.nativeElement, identityConstants.disabledClass)
        }
        else {
          this.render2.addClass(this.elementRef.nativeElement, identityConstants.disabledClass)
        }
      })
    ).subscribe();


  }



  @Input()
  set mmAuthorize(_: string) {
    this.authorize$.next(_);

  }

}
